/* SHELFIX shelf designer v2 — Shopify section script.
   Three.js loads after the page is ready (the real product photo shows first).
   Prices and variants always come from Shopify; add-ons from the add-on products. */
(function(){
var THREE_URL="https://cdn.jsdelivr.net/npm/three@0.147.0/build/three.min.js";
var ORBIT_URL="https://cdn.jsdelivr.net/npm/three@0.147.0/examples/js/controls/OrbitControls.js";
function loadScript(src){ return new Promise(function(res,rej){ var s=document.createElement("script"); s.src=src; s.onload=res; s.onerror=rej; document.head.appendChild(s); }); }
function loadThree(){ return (window.THREE?Promise.resolve():loadScript(THREE_URL)).then(function(){ return window.THREE.OrbitControls?null:loadScript(ORBIT_URL); }); }
function addonPrices(cfg){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/", jobs=[];
  cfg.cornerPrices={0:0}; cfg.radiusVariants={}; cfg.shapePrice=0; cfg.shapeVariant=null; cfg.holePrice=0; cfg.holeVariant=null;
  if(cfg.radiusHandle) jobs.push(fetch(root+"products/"+cfg.radiusHandle+".js").then(function(r){return r.json();}).then(function(p){
    p.variants.forEach(function(v){ var n=parseInt(v.option1||v.title,10); if(n>=1&&n<=4){ cfg.cornerPrices[n]=v.price/100; cfg.radiusVariants[n]=v.id; } }); }).catch(function(){}));
  if(cfg.shapeHandle) jobs.push(fetch(root+"products/"+cfg.shapeHandle+".js").then(function(r){return r.json();}).then(function(p){
    var v=p.variants[0]; cfg.shapePrice=v.price/100; cfg.shapeVariant=v.id; }).catch(function(){}));
  if(cfg.holeHandle) jobs.push(fetch(root+"products/"+cfg.holeHandle+".js").then(function(r){return r.json();}).then(function(p){
    var v=p.variants[0]; cfg.holePrice=v.price/100; cfg.holeVariant=v.id; }).catch(function(){}));
  return Promise.all(jobs);
}
function boot(ROOT){
  if(ROOT.__sxd) return; ROOT.__sxd=1;
  var CFG=JSON.parse(ROOT.querySelector("[data-sxd-config]").textContent);
  CFG.finishes.forEach(function(f){ if(f.tex&&f.tex.indexOf("//")===0) f.tex="https:"+f.tex; if(f.photo&&f.photo.indexOf("//")===0) f.photo="https:"+f.photo; });
  var poster=ROOT.querySelector("[data-poster]"), f0=CFG.finishes[CFG.start];
  if(poster&&f0&&f0.photo){ poster.src=f0.photo; poster.hidden=false; }
  var go=function(){ Promise.all([loadThree(),addonPrices(CFG)]).then(function(){
      designer(ROOT,CFG); ROOT.querySelector("[data-loading]").hidden=true; if(poster) poster.hidden=true;
    }).catch(function(){ ROOT.querySelector("[data-loading]").textContent="The 3D designer could not load. Please refresh the page."; }); };
  if(document.readyState==="complete") (window.requestIdleCallback||setTimeout)(go); else window.addEventListener("load",function(){ (window.requestIdleCallback||setTimeout)(go); });
}
function designer(ROOT,CFG){

/* ---------- Finishes: colors sampled from the real product photos ---------- */
const FINISHES = CFG.finishes;

/* ---------- Pricing (same table as the Shopify variant CSV) ---------- */
const EDGE_NAME = {front:"Front edge only (Length)", all:"All Edges"};
/* Corner radius: add-on line in the store. EXAMPLE PRICES — set your own. */
const CORNER_ADD = CFG.cornerPrices;   // from the "Corner Radius (add-on)" product
const CUSTOM_SHAPE_ADD = CFG.shapePrice;   // from the "Custom Shape (add-on)" product
const POS_NAME={fl:"front-left",fr:"front-right",br:"back-right",bl:"back-left"};
const DEFAULT_SET={1:["fr"],2:["fl","fr"],3:["fl","fr","br"],4:["fl","fr","br","bl"]};
const cornerList=()=>["fl","fr","br","bl"].filter(k=>state.cset[k]);
const cornerName=()=>{ const l=cornerList(); return l.length===4?"All 4 corners rounded":`${l.length} corner${l.length>1?"s":""} rounded (${l.map(k=>POS_NAME[k]).join(", ")})`; };
const T = 0.75, LIM = {L:[6,43+15/16], D:[6,24+15/16]};
const state = {L:24, D:12, edge:"front", fin:FINISHES[CFG.start], corner:"square", cset:{fl:true,fr:true,br:false,bl:false}, radius:1, edgeBefore:"front"};

/* ---------- Fractions ---------- */
const gcd=(a,b)=>b?gcd(b,a%b):a;
const fracLabel=n=>{ if(!n) return "0"; const g=gcd(n,16); return (n/g)+"/"+(16/g); };
const whole=x=>Math.floor(x+1e-9);
const fmt=x=>{ const w=whole(x), n=Math.round((x-w)*16); return n?`${w} ${fracLabel(n)}"`:`${w}"`; };
function parse(str){
  const s=String(str).trim().replace(/("|in(ches)?)$/i,"").trim();
  let m=s.match(/^(\d+)(?:[\s-]+(\d+)\/(\d+))?$/); if(m){ let v=+m[1]; if(m[2]) v+= +m[2]/+m[3]; return v; }
  m=s.match(/^(\d*\.\d+)$/); if(m) return +m[1];
  return NaN;
}
const $=id=>document.getElementById("sx-"+id);
const ui={L:{inp:$("lenIn"),frac:$("lenFrac"),range:$("lenRange"),help:$("lenHelp")},D:{inp:$("depIn"),frac:$("depFrac"),range:$("depRange"),help:$("depHelp")}};
for(const k of ["L","D"]) for(let i=0;i<16;i++){ const o=document.createElement("option"); o.value=i; o.textContent=i?`+ ${fracLabel(i)}"`:"+ 0"; ui[k].frac.appendChild(o); }

function setDim(k,v){
  const u=ui[k], [lo,hi]=LIM[k];
  if(isNaN(v)){ u.help.textContent='Type inches, e.g. 23 or 23 5/16'; u.help.classList.add("err"); return; }
  const s=Math.round(v*16)/16, c=Math.min(hi,Math.max(lo,s));
  u.help.classList.toggle("err",c!==s);
  u.help.textContent = c!==s ? (s>hi?`Max ${fmt(hi)}. Need bigger? Contact us.`:`Min ${fmt(lo)}.`) : `${fmt(lo)} to ${fmt(hi)}`;
  state[k]=c; update();
}
for(const k of ["L","D"]){
  const u=ui[k];
  u.inp.addEventListener("change",()=>{ const t=u.inp.value, v=parse(t); setDim(k, /[\/.]/.test(t)? v : v+(+u.frac.value)/16); });
  u.frac.addEventListener("change",()=>setDim(k, whole(state[k])+(+u.frac.value)/16));
  u.range.addEventListener("input",()=>setDim(k,+u.range.value));
}
ROOT.querySelectorAll("[data-step]").forEach(b=>b.addEventListener("click",()=>{ const k=b.dataset.step; setDim(k, state[k]+(+b.dataset.d)); }));
ROOT.querySelectorAll("[data-edge]").forEach(b=>b.addEventListener("click",()=>{
  if(b.disabled) return; state.edge=b.dataset.edge; ROOT.querySelectorAll("[data-edge]").forEach(x=>x.setAttribute("aria-pressed",x===b)); update();
}));

function setEdge(e){ state.edge=e; ROOT.querySelectorAll("[data-edge]").forEach(x=>x.setAttribute("aria-pressed",x.dataset.edge===e)); }
function syncCornerUI(){
  const n=cornerList().length;
  ROOT.querySelectorAll("[data-ccount]").forEach(x=>x.setAttribute("aria-pressed",+x.dataset.ccount===n));
  ROOT.querySelectorAll("[data-cpos]").forEach(x=>x.setAttribute("aria-pressed",!!state.cset[x.dataset.cpos]));
  const sh=$("cpShelf"); sh.style.borderRadius=["bl","br","fr","fl"].map(k=>state.cset[k]?"18px":"2px").join(" ");
  $("cpHelp").textContent = n ? `Rounded: ${cornerList().map(k=>POS_NAME[k]).join(", ")}. Tap a corner to change it.` : "Tap the corners you want rounded.";
}
$("cornerOn").addEventListener("change",e=>{
  const on=e.target.checked;
  $("cornerMenu").hidden=!on;
  if(on && !cornerList().length) DEFAULT_SET[2].forEach(k=>state.cset[k]=true);
  state.corner = on ? "on" : "square";
  syncCornerUI(); update();
});
ROOT.querySelectorAll("[data-ccount]").forEach(b=>b.addEventListener("click",()=>{
  const n=+b.dataset.ccount; state.cset={fl:false,fr:false,br:false,bl:false}; DEFAULT_SET[n].forEach(k=>state.cset[k]=true); syncCornerUI(); update();
}));
ROOT.querySelectorAll("[data-cpos]").forEach(b=>b.addEventListener("click",()=>{
  const k=b.dataset.cpos; state.cset[k]=!state.cset[k];
  if(!cornerList().length){ state.cset[k]=true; }          // keep at least one; untick "Round the corners" to remove all
  syncCornerUI(); update();
}));
ROOT.querySelectorAll("[data-cprice]").forEach(x=>x.textContent="+$"+CORNER_ADD[+x.dataset.cprice]);
$("radius").addEventListener("change",e=>{ state.radius=+e.target.value; update(); });

/* ---------- Optional custom drawing (inches, origin = back-left corner, y toward the front) ---------- */
const draw={on:false,strokes:[],points:[],history:[],closed:false,hover:null,drag:null,file:null};
const snap16=v=>Math.round(v*16)/16;
/* custom point shape (AutoCAD-style polyline through P1, P2, … closed back to P1) */
function segInter(a,b,c,d){ const o=(p,q,r)=>Math.sign((q[0]-p[0])*(r[1]-p[1])-(q[1]-p[1])*(r[0]-p[0]));
  return o(a,b,c)*o(a,b,d)<0 && o(c,d,a)*o(c,d,b)<0; }
function polyValid(){ const P=draw.points.map(p=>[p.x,p.y]), n=P.length; if(n<3) return false;
  let area=0; for(let i=0;i<n;i++){ const a=P[i], b=P[(i+1)%n]; area+=a[0]*b[1]-b[0]*a[1]; } if(Math.abs(area)<1) return false;
  for(let i=0;i<n;i++) for(let j=i+1;j<n;j++){ if(Math.abs(i-j)<=1 || (i===0&&j===n-1)) continue; if(segInter(P[i],P[(i+1)%n],P[j],P[(j+1)%n])) return false; }
  return true; }
function polyArea(){ let a=0; const P=draw.points, n=P.length; for(let i=0;i<n;i++){ const p=P[i], q=P[(i+1)%n]; a+=p.x*q.y-q.x*p.y; } return a/2; }
function customActive(){ return draw.on && draw.closed && polyValid(); }
function insertIndex(q){ const n=draw.points.length; if(n<3) return n; let best=n, bd=1e9;
  for(let i=0;i<n;i++){ const a=draw.points[i], b=draw.points[(i+1)%n], dx=b.x-a.x, dy=b.y-a.y, L2=dx*dx+dy*dy||1;
    const t=Math.max(0,Math.min(1,((q[0]-a.x)*dx+(q[1]-a.y)*dy)/L2)), d=Math.hypot(a.x+t*dx-q[0],a.y+t*dy-q[1]); if(d<bd){bd=d;best=i+1;} }
  return best; }
function applyLocks(){
  const lock = state.corner!=="square" || customActive(), front=ROOT.querySelector('[data-edge="front"]');
  if(lock && !state.locked){ state.edgeBefore=state.edge; setEdge("all"); }
  if(!lock && state.locked){ setEdge(state.edgeBefore); }
  state.locked=lock; front.disabled=lock; $("edgeLock").hidden=!lock;
  $("edgeLock").textContent = customActive() ? "Locked to All edges because the shelf has a custom shape." : "Locked to All edges because the corners are rounded.";
}
const ptLabel=(p,i)=>`P${i+1} · X ${fmt(p.x)} · Y ${fmt(state.D-p.y)}`;
function nearPoint(q){ let best=null,bd=0.45; draw.points.forEach(p=>{ const d=Math.hypot(p.x-q[0],p.y-q[1]); if(d<bd){bd=d;best=[p.x,p.y];} }); return best; }
function addPoint(x,y){ const q=[snap16(x),snap16(y)]; const idx=draw.closed?insertIndex(q):draw.points.length; draw.points.splice(idx,0,{x:q[0],y:q[1]}); draw.history.push({k:"point",i:idx}); afterDrawChange(); }
function afterDrawChange(){ showSel(); update(); }
$("ptRect").addEventListener("click",()=>{ const {L,D}=state;
  draw.points=[{x:0,y:D},{x:L,y:D},{x:L,y:0},{x:0,y:0}]; draw.closed=true; draw.history=[0,1,2,3].map(()=>({k:"point",i:0})).concat([{k:"close"}]); afterDrawChange(); });
function closeShape(){ if(draw.points.length<3||draw.closed) return; draw.closed=true; draw.history.push({k:"close"}); afterDrawChange(); }
$("ptClose").addEventListener("click",closeShape);
function renderPtList(){
  const ol=$("ptList"); ol.innerHTML="";
  draw.points.forEach((p,i)=>{ const li=document.createElement("li"); li.innerHTML=`<span><b>P${i+1}</b> X ${fmt(p.x)} · Y ${fmt(state.D-p.y)} <small>from front-left</small></span>`;
    const del=document.createElement("button"); del.type="button"; del.textContent="×"; del.setAttribute("aria-label",`Delete point P${i+1}`);
    del.addEventListener("click",()=>{ draw.points.splice(i,1); for(let k=draw.history.length-1;k>=0;k--){ if(draw.history[k]&&draw.history[k].k==="point"){ draw.history.splice(k,1); break; } } afterDrawChange(); });
    li.appendChild(del); ol.appendChild(li); });
}
$("ptAdd").addEventListener("click",()=>{
  const x=parse($("ptX").value), yf=parse($("ptY").value), err=$("ptErr");
  if(isNaN(x)||isNaN(yf)){ err.hidden=false; err.textContent='Enter X and Y in inches, e.g. 3 1/2'; return; }
  if(x<0||x>state.L||yf<0||yf>state.D){ err.hidden=false; err.textContent=`Point must be inside the shelf: X 0 to ${fmt(state.L)}, Y 0 to ${fmt(state.D)}.`; return; }
  err.hidden=true; addPoint(x,state.D-yf); $("ptX").value=""; $("ptY").value=""; $("ptX").focus();
});
["ptX","ptY"].forEach(id=>$(id).addEventListener("keydown",e=>{ if(e.key==="Enter") $("ptAdd").click(); }));
const pad=$("pad"), pctx=pad.getContext("2d");
let padMap={s:1,ox:0,oy:0};
$("drawOn").addEventListener("change",e=>{ draw.on=e.target.checked; $("drawMenu").hidden=!draw.on; if(draw.on) requestAnimationFrame(drawPad); update(); });

$("undo").addEventListener("click",()=>{ const k=draw.history.pop(); if(k&&k.k==="close") draw.closed=false; else if(k&&k.k==="point"){ draw.points.splice(Math.min(k.i,draw.points.length-1),1); if(draw.points.length<3) draw.closed=false; } afterDrawChange(); });
$("clear").addEventListener("click",()=>{ draw.points=[]; draw.history=[]; draw.closed=false; draw.sel=null; showSel(); afterDrawChange(); });
$("drawNote").addEventListener("input",updateDrawProps);
$("drawFile").addEventListener("change",e=>{ draw.file=e.target.files[0]||null; updateDrawProps(); });
function updateDrawProps(){
  const parts=[]; if(draw.points.length) parts.push((customActive()?"custom shape, ":"open, ")+draw.points.length+(draw.points.length>1?" points":" point")); if($("drawNote").value.trim()) parts.push("note"); if(draw.file) parts.push("file");
  $("pDraw").textContent = draw.on && parts.length ? parts.join(" + ") : "None";
}
function padToIn(ev){ const r=pad.getBoundingClientRect(); const x=(ev.clientX-r.left-padMap.ox)/padMap.s, y=(ev.clientY-r.top-padMap.oy)/padMap.s;
  return [Math.max(0,Math.min(state.L,x)), Math.max(0,Math.min(state.D,y))]; }
/* ---------- selecting points / lines and typing exact sizes ---------- */
draw.sel=null; // {type:"pt"|"seg", i}
const segCount=()=>draw.closed?draw.points.length:Math.max(0,draw.points.length-1);
const segPts=i=>[draw.points[i],draw.points[(i+1)%draw.points.length]];
const segLen=i=>{ const [a,b]=segPts(i); return Math.hypot(b.x-a.x,b.y-a.y); };
function hitSegment(p){ let best=-1,bd=0.4; for(let i=0;i<segCount();i++){ const [a,b]=segPts(i), dx=b.x-a.x, dy=b.y-a.y, L2=dx*dx+dy*dy||1;
  const t=Math.max(0,Math.min(1,((p[0]-a.x)*dx+(p[1]-a.y)*dy)/L2)), d=Math.hypot(a.x+t*dx-p[0],a.y+t*dy-p[1]); if(d<bd){bd=d;best=i;} } return best; }
function select(sel){ draw.sel=sel; showSel(); drawPad(); update(); }
function showSel(){
  const ed=$("selEdit"), sel=draw.sel; $("selErr").hidden=true;
  if(!sel || (sel.type==="pt" && !draw.points[sel.i]) || (sel.type==="seg" && sel.i>=segCount())){ draw.sel=null; ed.hidden=true; return; }
  ed.hidden=false;
  if(sel.type==="pt"){ const p=draw.points[sel.i];
    $("selName").textContent=`P${sel.i+1}`; $("selInfo").textContent="point · from front-left corner";
    $("selPt").hidden=false; $("selSeg").hidden=true; $("selSplit").hidden=true; $("selDel").hidden=false;
    if(document.activeElement!==$("selX")) $("selX").value=fmt(p.x).replace('"',''); if(document.activeElement!==$("selY")) $("selY").value=fmt(state.D-p.y).replace('"','');
  } else { const n=draw.points.length, j=(sel.i+1)%n;
    $("selName").textContent=`P${sel.i+1} → P${j+1}`; $("selInfo").textContent=`line · P${sel.i+1} stays, P${j+1} moves`;
    $("selPt").hidden=true; $("selSeg").hidden=false; $("selSplit").hidden=false; $("selDel").hidden=true;
    if(document.activeElement!==$("selLen")) $("selLen").value=fmt(snap16(segLen(sel.i))).replace('"','');
  }
}
function selError(t){ $("selErr").hidden=false; $("selErr").textContent=t; }
$("selApply").addEventListener("click",()=>{
  const sel=draw.sel; if(!sel) return;
  if(sel.type==="pt"){ const x=parse($("selX").value), yf=parse($("selY").value);
    if(isNaN(x)||isNaN(yf)) return selError('Type inches, e.g. 12 or 12 3/8');
    if(x<0||x>state.L||yf<0||yf>state.D) return selError(`Keep the point inside X 0–${fmt(state.L)}, Y 0–${fmt(state.D)}. Make the shelf bigger in step 1 if you need more room.`);
    draw.points[sel.i]={x:snap16(x),y:snap16(state.D-yf)};
  } else { const len=parse($("selLen").value); if(isNaN(len)||len<=0) return selError('Type a length in inches, e.g. 8 1/2');
    const [a,b]=segPts(sel.i), cur=segLen(sel.i)||1, nx=a.x+(b.x-a.x)/cur*len, ny=a.y+(b.y-a.y)/cur*len;
    if(nx<-1e-6||nx>state.L+1e-6||ny<-1e-6||ny>state.D+1e-6) return selError(`That length goes past the shelf edge. Max here is about ${fmt(snap16(maxLenAlong(a,b)))}.`);
    draw.points[(sel.i+1)%draw.points.length]={x:snap16(nx),y:snap16(ny)};
  }
  $("selErr").hidden=true; document.activeElement.blur(); showSel(); update();
});
function maxLenAlong(a,b){ const d=Math.hypot(b.x-a.x,b.y-a.y)||1, ux=(b.x-a.x)/d, uy=(b.y-a.y)/d; let t=1e9;
  if(ux>0) t=Math.min(t,(state.L-a.x)/ux); if(ux<0) t=Math.min(t,-a.x/ux); if(uy>0) t=Math.min(t,(state.D-a.y)/uy); if(uy<0) t=Math.min(t,-a.y/uy); return t; }
["selX","selY","selLen"].forEach(id=>$(id).addEventListener("keydown",e=>{ if(e.key==="Enter") $("selApply").click(); }));
$("selSplit").addEventListener("click",()=>{ const sel=draw.sel; if(!sel||sel.type!=="seg") return; const [a,b]=segPts(sel.i);
  draw.points.splice(sel.i+1,0,{x:snap16((a.x+b.x)/2),y:snap16((a.y+b.y)/2)}); draw.history.push({k:"point",i:sel.i+1}); select({type:"pt",i:sel.i+1}); });
$("selDel").addEventListener("click",()=>{ const sel=draw.sel; if(!sel||sel.type!=="pt") return; draw.points.splice(sel.i,1); if(draw.points.length<3) draw.closed=false; select(null); });

const HELP_OPEN='Click to place points. Each point connects to the last one with a straight line. Click P1 again (or Close shape) to finish.';
const HELP_DONE='Shape closed. Click a point or a line to select it and type an exact size. Drag points to move them.';
pad.addEventListener("pointerdown",ev=>{ const p=padToIn(ev);
  const hit=draw.points.findIndex(q=>Math.hypot(q.x-p[0],q.y-p[1])<0.5);
  if(!draw.closed && hit===0 && draw.points.length>=3){ closeShape(); return; }
  if(hit>-1){ pad.setPointerCapture(ev.pointerId); draw.drag=hit; select({type:"pt",i:hit}); return; }
  const sg=hitSegment(p);
  if(sg>-1 && (draw.closed || sg<segCount())){ select({type:"seg",i:sg}); return; }
  if(draw.closed){ select(null); return; }
  addPoint(p[0],p[1]); select(null); });
let dragRaf=0;
pad.addEventListener("pointermove",ev=>{ const p=padToIn(ev); draw.hover=p;
  if(draw.drag!=null){ draw.points[draw.drag]={x:snap16(p[0]),y:snap16(p[1])}; if(!dragRaf) dragRaf=requestAnimationFrame(()=>{ dragRaf=0; update(); }); }
  let txt=`X ${fmt(snap16(p[0]))} · Y ${fmt(snap16(state.D-p[1]))} from front-left`;
  const last=draw.points[draw.points.length-1];
  if(!draw.closed && last && draw.drag==null){ txt+=` · line ${fmt(snap16(Math.hypot(snap16(p[0])-last.x,snap16(p[1])-last.y)))}`; }
  $("padHelp").textContent=txt; drawPad(); });
function endDrag(){ if(draw.drag!=null){ draw.drag=null; showSel(); update(); } }
pad.addEventListener("pointerup",endDrag); pad.addEventListener("pointercancel",endDrag);
pad.addEventListener("pointerleave",()=>{ draw.hover=null; $("padHelp").textContent=draw.closed?HELP_DONE:HELP_OPEN; drawPad(); });

function roundRectPath(c,x,y,w,h,Q){ // Q = radii {fl,fr,br,bl}; top of the pad is the BACK
  const {fl=0,fr=0,br=0,bl=0}=Q||{};
  c.beginPath(); c.moveTo(x+bl,y); c.lineTo(x+w-br,y); if(br) c.arcTo(x+w,y,x+w,y+br,br);
  c.lineTo(x+w,y+h-fr); if(fr) c.arcTo(x+w,y+h,x+w-fr,y+h,fr); c.lineTo(x+fl,y+h); if(fl) c.arcTo(x,y+h,x,y+h-fl,fl);
  c.lineTo(x,y+bl); if(bl) c.arcTo(x,y,x+bl,y,bl); c.closePath(); }
function radii(r){ const o={}; ["fl","fr","br","bl"].forEach(k=>o[k]=state.corner!=="square"&&state.cset[k]?r:0); return o; }
function strokePaths(c,s,ox,oy,lw){
  c.strokeStyle="#1d3557"; c.lineWidth=lw; c.lineCap="round"; c.lineJoin="round";
  draw.strokes.forEach(st=>{ c.beginPath(); st.pts.forEach((p,i)=>{ const X=ox+p[0]*s, Y=oy+p[1]*s; i?c.lineTo(X,Y):c.moveTo(X,Y); }); if(st.pts.length===1){ c.lineTo(ox+st.pts[0][0]*s+0.1,oy+st.pts[0][1]*s); } c.stroke(); });
  // selected line + every line's length
  const n=draw.points.length, sel=draw.sel;
  for(let i=0;i<segCount();i++){ const [a,b]=segPts(i), X1=ox+a.x*s, Y1=oy+a.y*s, X2=ox+b.x*s, Y2=oy+b.y*s, isSel=sel&&sel.type==="seg"&&sel.i===i;
    if(isSel){ c.beginPath(); c.moveTo(X1,Y1); c.lineTo(X2,Y2); c.strokeStyle="#b8862f"; c.lineWidth=4; c.stroke(); }
    const len=segLen(i); if(len<0.5) continue;
    let nx=-(Y2-Y1), ny=X2-X1; const nl=Math.hypot(nx,ny)||1; nx/=nl; ny/=nl;
    const area=polyArea(); if(draw.closed && area<0){ nx=-nx; ny=-ny; }
    const mx=(X1+X2)/2+nx*11, my=(Y1+Y2)/2+ny*11, t=fmt(snap16(len));
    c.font="600 10px ui-monospace,Menlo,monospace"; c.textAlign="center"; c.textBaseline="middle";
    const tw=c.measureText(t).width+6; c.fillStyle=isSel?"#b8862f":"rgba(255,255,255,.9)"; c.fillRect(mx-tw/2,my-7,tw,14);
    c.fillStyle=isSel?"#fff":"#1d3557"; c.fillText(t,mx,my); c.textBaseline="alphabetic"; }
  // AutoCAD-style point marker: circle + cross, with P# tag
  const m=Math.max(5,lw*2.6);
  draw.points.forEach((p,i)=>{ const X=ox+p.x*s, Y=oy+p.y*s, isSel=sel&&sel.type==="pt"&&sel.i===i, col=isSel?"#b8862f":"#1d3557";
    c.strokeStyle=col; c.lineWidth=isSel?2.5:Math.max(1.2,lw*0.6); const mm=isSel?m*1.4:m;
    c.beginPath(); c.arc(X,Y,mm*0.6,0,Math.PI*2); c.moveTo(X-mm,Y); c.lineTo(X+mm,Y); c.moveTo(X,Y-mm); c.lineTo(X,Y+mm); c.stroke();
    if(isSel){ c.fillStyle="rgba(184,134,47,.18)"; c.beginPath(); c.arc(X,Y,mm*0.6,0,Math.PI*2); c.fill(); }
    c.fillStyle=col; c.font=`600 ${Math.max(10,m*1.5)}px ui-monospace,Menlo,monospace`; c.textAlign="left"; c.fillText("P"+(i+1),X+mm*0.9,Y-mm*0.7); });
}
function drawPad(){
  if(!draw.on) return;
  const dpr=Math.min(2,window.devicePixelRatio||1), W=pad.clientWidth, H=pad.clientHeight; if(!W) return;
  pad.width=W*dpr; pad.height=H*dpr; pctx.setTransform(dpr,0,0,dpr,0,0); pctx.clearRect(0,0,W,H);
  const {L,D}=state, s=Math.min((W-24)/L,(H-40)/D), ox=(W-L*s)/2, oy=(H-22-D*s)/2; padMap={s,ox,oy};
  const r=customActive()?0:(state.r||0), Qs=radii(r*s);
  pctx.save(); roundRectPath(pctx,ox,oy,L*s,D*s,Qs); pctx.fillStyle="#fbfbf9"; pctx.fill(); pctx.clip();
  pctx.strokeStyle="#eceae4"; pctx.lineWidth=1;
  for(let i=1;i<L;i++){ pctx.beginPath(); pctx.moveTo(ox+i*s,oy); pctx.lineTo(ox+i*s,oy+D*s); pctx.stroke(); }
  for(let j=1;j<D;j++){ pctx.beginPath(); pctx.moveTo(ox,oy+j*s); pctx.lineTo(ox+L*s,oy+j*s); pctx.stroke(); }
  if(draw.points.length){ const ok=draw.closed && polyValid(), bad=draw.closed && !ok;
    pctx.beginPath(); draw.points.forEach((q,i)=>{ const X=ox+q.x*s, Y=oy+q.y*s; i?pctx.lineTo(X,Y):pctx.moveTo(X,Y); }); if(draw.closed) pctx.closePath();
    if(ok){ pctx.fillStyle="rgba(29,53,87,.12)"; pctx.fill(); }
    pctx.setLineDash(bad?[5,4]:[]); pctx.strokeStyle=bad?"#b3261e":"#1d3557"; pctx.lineWidth=2; pctx.stroke(); pctx.setLineDash([]);
    if(!draw.closed && draw.hover && draw.drag==null){ const l=draw.points[draw.points.length-1];
      pctx.beginPath(); pctx.moveTo(ox+l.x*s,oy+l.y*s); pctx.lineTo(ox+snap16(draw.hover[0])*s,oy+snap16(draw.hover[1])*s); pctx.setLineDash([4,4]); pctx.strokeStyle="#1d3557"; pctx.lineWidth=1.5; pctx.stroke(); pctx.setLineDash([]); } }
  pctx.restore();
  roundRectPath(pctx,ox,oy,L*s,D*s,Qs); pctx.strokeStyle= customActive()?"#b9b7b0":"#1c1f23"; pctx.setLineDash(customActive()?[4,4]:[]); pctx.lineWidth=1.5; pctx.stroke(); pctx.setLineDash([]);
  strokePaths(pctx,s,ox,oy,2);
  pctx.fillStyle="#5e636b"; pctx.font="11px ui-monospace,Menlo,monospace"; pctx.textAlign="center";
  pctx.fillText(`FRONT · ${fmt(L)}`, W/2, oy+D*s+16);
}
new ResizeObserver(()=>drawPad()).observe(pad);



/* ---------- Optional holes (pad coordinates: x from left, y from back; stored like custom points) ---------- */
const HOLE_FEE = CFG.holePrice;
const holes={on:false,list:[],d:1,sel:-1};
const HOLE_EDGE=3/8;                                    // min. material between hole edge and shelf edge
function pointInPoly(x,y,P){ let c=false; for(let i=0,j=P.length-1;i<P.length;j=i++){ const a=P[i], b=P[j];
  if(((a.y>y)!==(b.y>y)) && (x < (b.x-a.x)*(y-a.y)/((b.y-a.y)||1e-9)+a.x)) c=!c; } return c; }
function distSeg(px,py,a,b){ const dx=b.x-a.x, dy=b.y-a.y, L2=dx*dx+dy*dy||1, t=Math.max(0,Math.min(1,((px-a.x)*dx+(py-a.y)*dy)/L2)); return Math.hypot(a.x+t*dx-px,a.y+t*dy-py); }
function holeProblem(h,i){
  const {L,D}=state, r=h.d/2, m=r+HOLE_EDGE;
  if(customActive()){ const P=draw.points; if(!pointInPoly(h.x,h.y,P)) return "outside the shelf";
    for(let k=0;k<P.length;k++){ if(distSeg(h.x,h.y,P[k],P[(k+1)%P.length])<m) return "too close to the edge"; } }
  else { if(h.x<m||h.x>L-m||h.y<m||h.y>D-m) return "too close to the edge";
    const rr=state.r||0; if(rr){ const cs={fl:[rr,D-rr],fr:[L-rr,D-rr],br:[L-rr,rr],bl:[rr,rr]};
      for(const k of cornerList()){ const c=cs[k], inCorner=(k[1]==="l"?h.x<c[0]:h.x>c[0]) && (k[0]==="f"?h.y>c[1]:h.y<c[1]);
        if(inCorner && Math.hypot(h.x-c[0],h.y-c[1])>rr-m) return "too close to the rounded corner"; } } }
  for(let k=0;k<holes.list.length;k++){ if(k===i) continue; const o=holes.list[k]; if(Math.hypot(o.x-h.x,o.y-h.y) < r+o.d/2+HOLE_EDGE) return "overlaps hole H"+(k+1); }
  return null; }
function holesActive(){ return holes.on && holes.list.length>0; }
function holesValid(){ return holes.list.every((h,i)=>!holeProblem(h,i)); }
const hpad=$("holePad"), hctx=hpad.getContext("2d"); let hMap={s:1,ox:0,oy:0};
$("holeOn").addEventListener("change",e=>{ holes.on=e.target.checked; $("holeMenu").hidden=!holes.on; if(holes.on) requestAnimationFrame(drawHolePad); update(); });
$("holeD").addEventListener("change",e=>{ holes.d=+e.target.value; if(holes.sel>-1){ holes.list[holes.sel].d=holes.d; } update(); });
function addHole(x,y){ if(holes.list.length>=40){ holeErr("Max 40 holes online. Contact us for more."); return; }
  holes.list.push({x:snap16(x),y:snap16(y),d:holes.d}); holes.sel=-1; update(); }
function holeErr(t){ const e=$("holeErr"); e.hidden=!t; e.textContent=t||""; }
$("holeAdd").addEventListener("click",()=>{ const x=parse($("holeX").value), yf=parse($("holeY").value);
  if(isNaN(x)||isNaN(yf)) return holeErr('Enter X and Y in inches, e.g. 3 1/2');
  if(x<0||x>state.L||yf<0||yf>state.D) return holeErr(`Hole center must be inside the shelf: X 0 to ${fmt(state.L)}, Y 0 to ${fmt(state.D)}.`);
  holeErr(""); addHole(x,state.D-yf); $("holeX").value=""; $("holeY").value=""; });
["holeX","holeY"].forEach(id=>$(id).addEventListener("keydown",e=>{ if(e.key==="Enter") $("holeAdd").click(); }));
$("holeClear").addEventListener("click",()=>{ holes.list=[]; holes.sel=-1; holeErr(""); update(); });
function hpToIn(ev){ const r=hpad.getBoundingClientRect(); return [Math.max(0,Math.min(state.L,(ev.clientX-r.left-hMap.ox)/hMap.s)), Math.max(0,Math.min(state.D,(ev.clientY-r.top-hMap.oy)/hMap.s))]; }
let hDrag=-1;
hpad.addEventListener("pointerdown",ev=>{ const p=hpToIn(ev);
  const hit=holes.list.findIndex(h=>Math.hypot(h.x-p[0],h.y-p[1])<Math.max(h.d/2,0.45));
  if(hit>-1){ holes.sel=hit; hDrag=hit; hpad.setPointerCapture(ev.pointerId); $("holeD").value=String(holes.list[hit].d); update(); return; }
  addHole(p[0],p[1]); });
hpad.addEventListener("pointermove",ev=>{ const p=hpToIn(ev);
  $("holeHelp").textContent=`X ${fmt(snap16(p[0]))} · Y ${fmt(snap16(state.D-p[1]))} from front-left`;
  if(hDrag>-1){ holes.list[hDrag].x=snap16(p[0]); holes.list[hDrag].y=snap16(p[1]); update(); } });
function hEnd(){ hDrag=-1; } hpad.addEventListener("pointerup",hEnd); hpad.addEventListener("pointercancel",hEnd);
hpad.addEventListener("pointerleave",()=>{ $("holeHelp").textContent="Click the shelf to add a hole. Drag a hole to move it."; });
function renderHoleList(){
  const ol=$("holeList"); ol.innerHTML="";
  holes.list.forEach((h,i)=>{ const li=document.createElement("li"), bad=holeProblem(h,i); if(i===holes.sel) li.className="sel"; if(bad) li.classList.add("bad");
    li.innerHTML=`<span><b>H${i+1}</b> Ø ${fmt(h.d)} · X ${fmt(h.x)} · Y ${fmt(state.D-h.y)}${bad?` <em>${bad}</em>`:""}</span>`;
    li.addEventListener("click",()=>{ holes.sel=i; $("holeD").value=String(h.d); update(); });
    const del=document.createElement("button"); del.type="button"; del.textContent="×"; del.setAttribute("aria-label",`Delete hole H${i+1}`);
    del.addEventListener("click",e=>{ e.stopPropagation(); holes.list.splice(i,1); holes.sel=-1; update(); });
    li.appendChild(del); ol.appendChild(li); });
  const n=holes.list.length;
  $("holeSum").textContent = n ? `${n} hole${n>1?"s":""} × $${HOLE_FEE} = $${(n*HOLE_FEE).toFixed(2)}` : "No holes yet.";
}
function outlinePath(c,s,ox,oy){
  if(customActive()){ c.beginPath(); draw.points.forEach((q,i)=>{ const X=ox+q.x*s, Y=oy+q.y*s; i?c.lineTo(X,Y):c.moveTo(X,Y); }); c.closePath(); }
  else roundRectPath(c,ox,oy,state.L*s,state.D*s,radii((state.r||0)*s));
}
function drawHolePad(){
  if(!holes.on) return;
  const dpr=Math.min(2,window.devicePixelRatio||1), W=hpad.clientWidth, H=hpad.clientHeight; if(!W) return;
  hpad.width=W*dpr; hpad.height=H*dpr; hctx.setTransform(dpr,0,0,dpr,0,0); hctx.clearRect(0,0,W,H);
  const {L,D}=state, s=Math.min((W-24)/L,(H-40)/D), ox=(W-L*s)/2, oy=(H-22-D*s)/2; hMap={s,ox,oy};
  outlinePath(hctx,s,ox,oy); hctx.fillStyle="#fbfbf9"; hctx.fill(); hctx.strokeStyle="#1c1f23"; hctx.lineWidth=1.5; hctx.stroke();
  holes.list.forEach((h,i)=>{ const X=ox+h.x*s, Y=oy+h.y*s, R=Math.max(3,h.d/2*s), bad=holeProblem(h,i), isSel=i===holes.sel;
    hctx.beginPath(); hctx.arc(X,Y,R,0,Math.PI*2); hctx.fillStyle=bad?"rgba(179,38,30,.15)":"#ffffff"; hctx.fill();
    hctx.strokeStyle=bad?"#b3261e":(isSel?"#b8862f":"#1d3557"); hctx.lineWidth=isSel?2.5:1.6; hctx.stroke();
    hctx.beginPath(); hctx.moveTo(X-R-4,Y); hctx.lineTo(X+R+4,Y); hctx.moveTo(X,Y-R-4); hctx.lineTo(X,Y+R+4); hctx.lineWidth=0.8; hctx.stroke();
    hctx.fillStyle=bad?"#b3261e":(isSel?"#b8862f":"#1d3557"); hctx.font="600 11px ui-monospace,Menlo,monospace"; hctx.textAlign="left"; hctx.fillText("H"+(i+1),X+R+5,Y-R-2); });
  hctx.fillStyle="#5e636b"; hctx.font="11px ui-monospace,Menlo,monospace"; hctx.textAlign="center"; hctx.fillText(`FRONT · ${fmt(L)}`, W/2, oy+D*s+16);
}
new ResizeObserver(()=>drawHolePad()).observe(hpad);

/* swatches */
const swWrap=$("swatches");
FINISHES.forEach((f,i)=>{
  const b=document.createElement("button"); b.type="button"; b.className="sw"; b.setAttribute("aria-pressed", i===CFG.start);
  const ic=document.createElement("i"); ic.style.background = f.tex ? `url(${f.tex}) center/cover` : f.color;
  const sp=document.createElement("span"); sp.textContent=f.name;
  b.append(ic,sp); b.addEventListener("click",()=>{ state.fin=f; swWrap.querySelectorAll(".sw").forEach(x=>x.setAttribute("aria-pressed",x===b)); applyFinish(); if(CFG.isProduct && f.url && history.replaceState){ try{ history.replaceState(null,"",f.url); }catch(e){} } update(); });
  swWrap.appendChild(b);
});

/* real photo card + lightbox */
$("real").addEventListener("click",()=>{ $("lbImg").src=state.fin.photo; $("lbImg").alt=`Real photo of a ${state.fin.name} melamine shelf`; $("lbCap").textContent=`${state.fin.name} · real product photo. Tap anywhere to close.`; $("lightbox").hidden=false; });
$("lightbox").addEventListener("click",()=>{ $("lightbox").hidden=true; });
document.addEventListener("keydown",e=>{ if(e.key==="Escape") $("lightbox").hidden=true; });

/* ---------- Three.js ---------- */
const canvas=$("cv"), stage=$("stage"), labels=$("labels");
const renderer=new THREE.WebGLRenderer({canvas,antialias:true});
renderer.setPixelRatio(Math.min(2,window.devicePixelRatio||1));
renderer.setClearColor(0xffffff);
const scene=new THREE.Scene();
const cam=new THREE.OrthographicCamera(-1,1,1,-1,-500,500);
const controls=new THREE.OrbitControls(cam,canvas);
controls.enableDamping=false; controls.enablePan=false; controls.maxPolarAngle=Math.PI/2; controls.minZoom=0.6; controls.maxZoom=6;
controls.addEventListener("change",()=>{ render(); ROOT.querySelectorAll("[data-view]").forEach(x=>x.setAttribute("aria-pressed",false)); });

// faint drafting grid
const g1=new THREE.GridHelper(96,96,0xf0efeb,0xf0efeb); g1.position.y=-0.02; scene.add(g1);
const g12=new THREE.GridHelper(96,8,0xe2e1dc,0xe2e1dc); g12.position.y=-0.01; scene.add(g12);

// soft contact shadow
const sc=document.createElement("canvas"); sc.width=sc.height=128; const sx=sc.getContext("2d");
const grd=sx.createRadialGradient(64,64,10,64,64,64); grd.addColorStop(0,"rgba(0,0,0,.22)"); grd.addColorStop(1,"rgba(0,0,0,0)");
sx.fillStyle=grd; sx.fillRect(0,0,128,128);
const shadow=new THREE.Mesh(new THREE.PlaneGeometry(1,1),new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(sc),transparent:true,depthWrite:false}));
shadow.rotation.x=-Math.PI/2; shadow.position.y=0.005; scene.add(shadow);

// particleboard core texture (unbanded cut edges)
function coreTexture(){
  const c=document.createElement("canvas"); c.width=256; c.height=64; const x=c.getContext("2d");
  x.fillStyle="#b8915f"; x.fillRect(0,0,256,64);
  for(let i=0;i<1400;i++){ const v=Math.random(); x.fillStyle=v<.5?"rgba(120,85,45,.55)":"rgba(225,195,150,.6)"; x.fillRect(Math.random()*256,Math.random()*64,1+Math.random()*2.5,1+Math.random()*1.5); }
  const t=new THREE.CanvasTexture(c); t.wrapS=t.wrapT=THREE.RepeatWrapping; return t;
}
const coreTex=coreTexture();

const loader=new THREE.TextureLoader(); loader.setCrossOrigin("anonymous");
const texCache={};
function finishTex(f){
  if(!f.tex) return null;
  if(!texCache[f.id]){ const t=loader.load(f.tex,render); t.wrapS=t.wrapT=THREE.MirroredRepeatWrapping; t.anisotropy=4; texCache[f.id]=t; }
  return texCache[f.id];
}
// materials: 0 top, 1 bottom, 2 banded edge, 3 raw particleboard edge
const SHADE=[1,0.7,0.9,0.86];
const mats=SHADE.map(()=>new THREE.MeshBasicMaterial({color:0xffffff}));
const body=new THREE.Mesh(new THREE.BufferGeometry(),mats); scene.add(body);
const outlineMat=new THREE.LineBasicMaterial({color:0x1c1f23,transparent:true,opacity:0.28});
const outline=new THREE.LineSegments(new THREE.BufferGeometry(),outlineMat); scene.add(outline);

/* drawing decal on the top face */
const decalCanvas=document.createElement("canvas"), decalCtx=decalCanvas.getContext("2d");
const decalTex=new THREE.CanvasTexture(decalCanvas);
const decal=new THREE.Mesh(new THREE.PlaneGeometry(1,1),new THREE.MeshBasicMaterial({map:decalTex,transparent:true,depthWrite:false}));
decal.rotation.x=-Math.PI/2; decal.visible=false; scene.add(decal);
function refreshDecal(){
  const {L,D}=state, has=false; decal.visible=has;
  if(has){ const ppi=Math.min(40,2048/Math.max(L,D)); decalCanvas.width=Math.round(L*ppi); decalCanvas.height=Math.round(D*ppi);
    decalCtx.clearRect(0,0,decalCanvas.width,decalCanvas.height); strokePaths(decalCtx,ppi,0,0,Math.max(2,0.14*ppi));
    decalTex.needsUpdate=true; decal.scale.set(L,D,1); decal.position.set(0,T+0.02,0); }
  render();
}

/* Shelf outline with optional corner radius (rf = front corners, rb = back corners) */
function shelfGeometry(L,D,Q,allBanded,poly,hl){
  const {fl=0,fr=0,br=0,bl=0}=Q||{};
  const s=new THREE.Shape(), x0=-L/2, x1=L/2, y0=-D/2, y1=D/2;   // y0 becomes the FRONT edge
  if(poly){ poly.forEach((q,i)=>{ const X=q.x-L/2, Y=D/2-q.y; i?s.lineTo(X,Y):s.moveTo(X,Y); }); s.closePath(); }
  else {
  s.moveTo(x0+fl,y0); s.lineTo(x1-fr,y0); if(fr) s.absarc(x1-fr,y0+fr,fr,-Math.PI/2,0,false);
  s.lineTo(x1,y1-br); if(br) s.absarc(x1-br,y1-br,br,0,Math.PI/2,false);
  s.lineTo(x0+bl,y1); if(bl) s.absarc(x0+bl,y1-bl,bl,Math.PI/2,Math.PI,false);
  s.lineTo(x0,y0+fl); if(fl) s.absarc(x0+fl,y0+fl,fl,Math.PI,1.5*Math.PI,false);
  }
  const HC=(hl||[]).map(h=>({X:h.x-L/2, Y:D/2-h.y, r:h.d/2}));
  HC.forEach(h=>{ const ph=new THREE.Path(); ph.absarc(h.X,h.Y,h.r,0,Math.PI*2,true); s.holes.push(ph); });
  const g=new THREE.ExtrudeGeometry(s,{depth:T,bevelEnabled:false,curveSegments:18}).toNonIndexed();
  g.rotateX(-Math.PI/2);                                   // lie flat: y = 0..T, front edge at +z
  const P=g.attributes.position.array, U=g.attributes.uv.array, n=P.length/9;
  const buckets=[[],[],[],[]], a=new THREE.Vector3(), b=new THREE.Vector3(), c=new THREE.Vector3();
  for(let t=0;t<n;t++){
    a.fromArray(P,t*9); b.fromArray(P,t*9+3); c.fromArray(P,t*9+6);
    const nn=b.clone().sub(a).cross(c.clone().sub(a)).normalize();
    let cat;
    const cx=(a.x+b.x+c.x)/3, cy=-(a.z+b.z+c.z)/3;
    if(Math.abs(nn.y)<=0.9 && HC.some(h=>Math.abs(Math.hypot(cx-h.X,cy-h.Y)-h.r)<0.05)){ buckets[3].push(t); continue; }   // drilled hole walls: raw core
    if(nn.y>0.9) cat=0; else if(nn.y<-0.9) cat=1;
    else if(nn.z>0.97) cat=2;                                 // straight front edge: always banded
    else if(nn.z<-0.97 || Math.abs(nn.x)>0.97) cat=allBanded?2:3;
    else cat=2;                                               // rounded corners are always banded
    buckets[cat].push(t);
  }
  const pos=[], uv=[], out=new THREE.BufferGeometry(); let start=0;
  buckets.forEach((list,mi)=>{ list.forEach(t=>{ for(let k=0;k<9;k++) pos.push(P[t*9+k]); for(let k=0;k<6;k++) uv.push(U[t*6+k]); }); out.addGroup(start,list.length*3,mi); start+=list.length*3; });
  out.setAttribute("position",new THREE.Float32BufferAttribute(pos,3));
  out.setAttribute("uv",new THREE.Float32BufferAttribute(uv,2));
  return out;
}

function shadeColor(hex,f){ return new THREE.Color(hex).multiplyScalar(f); }
function applyFinish(){
  const f=state.fin;
  $("realImg").src=f.photo; $("realImg").alt=`Real photo of a ${f.name} melamine shelf`; $("realName").textContent=f.name;
}
/* UVs are in inches, so textures keep real scale at any size */
function setMats(){
  const f=state.fin;
  [0,1,2].forEach(i=>{ const m=mats[i];
    if(f.tex){ if(!m.map || m.map.__fin!==f.id){ const t=finishTex(f).clone(); t.needsUpdate=true; t.repeat.set(1/24,1/12); t.__fin=f.id; m.map=t; } m.color.setScalar(SHADE[i]); }
    else { m.map=null; m.color.copy(i===0? new THREE.Color(f.color) : shadeColor(f.color,SHADE[i])); }
    m.needsUpdate=true; });
  if(!mats[3].map){ const t=coreTex.clone(); t.needsUpdate=true; t.repeat.set(1/8,1/1.5); mats[3].map=t; mats[3].color.setScalar(SHADE[3]); mats[3].needsUpdate=true; }
}

// dimension layer
const dimGroup=new THREE.Group(); scene.add(dimGroup);
const dimMat=new THREE.LineBasicMaterial({color:0x1d3557});
function seg(p){ dimGroup.add(new THREE.LineSegments(new THREE.BufferGeometry().setFromPoints(p.map(a=>new THREE.Vector3(...a))),dimMat)); }
const lbl={L:mk(""),D:mk(""),T:mk("t"),R:mk("t")}, anc={L:new THREE.Vector3(),D:new THREE.Vector3(),T:new THREE.Vector3(),R:new THREE.Vector3(0,-999,0)};
function mk(c){ const d=document.createElement("div"); d.className="lbl "+c; labels.appendChild(d); return d; }
const segLblPool=[]; let segAnc=[];
function buildShapeDims(L,D){
  segAnc=[]; const n=draw.points.length, ccw=polyArea()>0, sel=draw.sel;
  for(let i=0;i<n;i++){ const a=draw.points[i], b=draw.points[(i+1)%n];
    const ax=a.x-L/2, az=a.y-D/2, bx=b.x-L/2, bz=b.y-D/2, len=Math.hypot(bx-ax,bz-az); if(len<0.5) continue;
    let nx=-(bz-az)/len, nz=(bx-ax)/len; if(ccw){ nx=-nx; nz=-nz; }   // outward normal (pad y = +z)
    const o=2.2, e=0.5, k=0.35, tx=(bx-ax)/len, tz=(bz-az)/len;
    const A=[ax+nx*o,0,az+nz*o], B=[bx+nx*o,0,bz+nz*o];
    seg([[ax+nx*.4,0,az+nz*.4],[ax+nx*(o+e),0,az+nz*(o+e)],[bx+nx*.4,0,bz+nz*.4],[bx+nx*(o+e),0,bz+nz*(o+e)],A,B,
         [A[0]-(tx+nx)*k,0,A[2]-(tz+nz)*k],[A[0]+(tx+nx)*k,0,A[2]+(tz+nz)*k],[B[0]-(tx+nx)*k,0,B[2]-(tz+nz)*k],[B[0]+(tx+nx)*k,0,B[2]+(tz+nz)*k]]);
    segAnc.push({v:new THREE.Vector3((A[0]+B[0])/2,0,(A[2]+B[2])/2), t:fmt(snap16(len)), sel:!!(sel&&sel.type==="seg"&&sel.i===i)});
  }
  while(segLblPool.length<segAnc.length) segLblPool.push(mk("seg"));
  segLblPool.forEach((el,i)=>{ const a=segAnc[i]; el.hidden=!a; if(a){ el.textContent=a.t; el.classList.toggle("sel",a.sel); } });
}
function buildDims(L,D){
  dimGroup.clear();
  if(customActive()){ ["L","D"].forEach(k=>anc[k].set(0,-999,0)); seg([[ (-L/2),T,D/2],[(-L/2)-1.5,T+5,D/2]]); anc.T.set(-L/2-1.5,T+6,D/2); buildShapeDims(L,D); return; }
  segLblPool.forEach(el=>el.hidden=true); segAnc=[];
  const o=3, e=0.6, k=0.45, x0=-L/2, x1=L/2, z0=-D/2, z1=D/2, zl=z1+o, xd=x1+o;
  seg([[x0,0,z1+.4],[x0,0,zl+e],[x1,0,z1+.4],[x1,0,zl+e],[x0,0,zl],[x1,0,zl],[x0-k,0,zl+k],[x0+k,0,zl-k],[x1-k,0,zl+k],[x1+k,0,zl-k]]);
  seg([[x1+.4,0,z0],[xd+e,0,z0],[x1+.4,0,z1],[xd+e,0,z1],[xd,0,z0],[xd,0,z1],[xd-k,0,z0+k],[xd+k,0,z0-k],[xd-k,0,z1+k],[xd+k,0,z1-k]]);
  seg([[x0,T,z1],[x0-1.5,T+5,z1]]);
  anc.L.set(0,0,zl); anc.D.set(xd,0,0); anc.T.set(x0-1.5,T+6,z1);
}

/* camera */
const VIEWS={iso:[1,0.85,1],top:[0,1,0.0001],front:[0,0.0001,1]};
function setView(v){ const d=VIEWS[v]; cam.position.set(d[0]*100,d[1]*100,d[2]*100); cam.zoom=1; controls.target.set(0,0,0); cam.updateProjectionMatrix(); controls.update();
  ROOT.querySelectorAll("[data-view]").forEach(x=>x.setAttribute("aria-pressed",x.dataset.view===v)); render(); }
ROOT.querySelectorAll("[data-view]").forEach(b=>b.addEventListener("click",()=>setView(b.dataset.view)));
function resize(){ const w=stage.clientWidth,h=stage.clientHeight; if(!w||!h) return; renderer.setSize(w,h,false);
  const a=w/h, span=50, hh= a>=1 ? span/2/Math.min(a,1.9)*1.15 : span/2/a;
  cam.left=-hh*a; cam.right=hh*a; cam.top=hh; cam.bottom=-hh; cam.updateProjectionMatrix(); render(); }
new ResizeObserver(resize).observe(stage);
function render(){ renderer.render(scene,cam); const w=stage.clientWidth,h=stage.clientHeight,v=new THREE.Vector3();
  for(const k in anc){ v.copy(anc[k]).project(cam); lbl[k].style.left=((v.x+1)/2*w)+"px"; lbl[k].style.top=((1-v.y)/2*h)+"px"; }
  segAnc.forEach((a,i)=>{ v.copy(a.v).project(cam); segLblPool[i].style.left=((v.x+1)/2*w)+"px"; segLblPool[i].style.top=((1-v.y)/2*h)+"px"; }); }

/* ---------- Update ---------- */
function update(){
  applyLocks();
  const {L,D,edge,fin}=state, all=edge==="all", custom=customActive();
  // corner radius (limited by the shelf size)
  const corner=state.corner, maxR=Math.floor(Math.min(L,D)/2*16-1)/16, ncorner=corner==="square"?0:cornerList().length;
  let r=(corner==="square"||custom)?0:Math.min(state.radius,maxR);
  $("radiusOff").hidden=!(custom && corner!=="square");
  $("radiusHelp").hidden = corner==="square" || r>=state.radius;
  $("radiusHelp").textContent = `Radius limited to ${fmt(r)} for this size.`;
  const Q=radii(r);
  const geo=shelfGeometry(L,D,Q,all,custom?draw.points:null,holesActive()?holes.list.filter((h,i)=>!holeProblem(h,i)):null);
  const st=$("shapeState");
  const badShape=draw.on && draw.closed && !custom;
  st.classList.toggle("ok",custom); st.classList.toggle("err",badShape);
  st.textContent = custom ? `Custom shape from ${draw.points.length} points is shown in 3D. Custom shape +$${CUSTOM_SHAPE_ADD} is added to the price.` : badShape ? "Lines cross or the shape is too small. Drag a point to fix it." : draw.points.length>=3 ? "Click P1 or Close shape to finish." : "Place 3 or more points, then close the shape.";
  $("ptClose").disabled = draw.closed || draw.points.length<3;
  if(!draw.hover) $("padHelp").textContent = draw.closed ? HELP_DONE : HELP_OPEN;
  body.geometry.dispose(); body.geometry=geo;
  outline.geometry.dispose(); outline.geometry=new THREE.EdgesGeometry(geo,25);
  if(custom) shadow.scale.set(L*1.1,1,D*1.25); else shadow.scale.set(L*1.35,1,D*1.6);
  setMats();
  buildDims(L,D); lbl.L.textContent=fmt(L); lbl.D.textContent=fmt(D); lbl.T.textContent='3/4"';
  if(r){ const k=cornerList()[0], sx=(k==="fr"||k==="br")?1:-1, sz=(k==="fl"||k==="fr")?1:-1;
    anc.R.set(sx*(L/2-r*0.29+1.8),T,sz*(D/2-r*0.29+1.8)); lbl.R.textContent=`R ${fmt(r)}`; } else { anc.R.set(0,-999,0); lbl.R.textContent=""; }
  const Lw=whole(L), Dw=whole(D);
  state.r=r; state.addon = (custom?CUSTOM_SHAPE_ADD:(r?(CORNER_ADD[ncorner]||0):0)) + (holesActive()?holes.list.length*HOLE_FEE:0);
  schedulePrice(Lw,Dw,EDGE_NAME[edge]);
  $("pSize").textContent=`${fmt(L)} × ${fmt(D)}`;
  $("pMm").textContent=`${Math.round(L*25.4)} × ${Math.round(D*25.4)} × 19 mm`;
  $("pVar").textContent=`${Lw}" × ${Dw}"`;
  $("pCorner").textContent= custom ? `Custom shape · ${draw.points.length} points` : (r ? `${ncorner} · R ${fmt(r)}` : "Square");
  $("pHoles").textContent = holesActive() ? `${holes.list.length} × Ø ${[...new Set(holes.list.map(h=>fmt(h.d)))].join(", ")}` : "None";
  const hbad=holes.list.map((h,i)=>holeProblem(h,i)).find(Boolean); if(holes.on) holeErr(hbad?"Fix the red hole: "+hbad+".":"");
  drawPad(); drawHolePad(); renderHoleList(); refreshDecal(); updateDrawProps(); renderPtList();
  $("cmd").innerHTML=`<span>LENGTH <b>${fmt(L)}</b></span><span>DEPTH <b>${fmt(D)}</b></span><span>THK <b>3/4"</b></span><span>EDGE <b>${EDGE_NAME[edge]}</b></span><span>FINISH <b>${fin.name}</b></span><span>${custom?"SHAPE":"CORNERS"} <b>${custom?"Custom, "+draw.points.length+" points":(r?cornerName()+" R "+fmt(r):"Square")}</b></span>${holesActive()?`<span>HOLES <b>${holes.list.length}</b></span>`:""}${draw.on&&$("pDraw").textContent!=="None"?`<span>NOTES <b>attached</b></span>`:""}`;
  canvas.setAttribute("aria-label",`${fin.name} melamine shelf, ${fmt(L)} long by ${fmt(D)} deep, 3/4 inch thick, ${all?"edge banded on all sides":"edge banded on the front edge"}`);
  for(const k of ["L","D"]){ const u=ui[k], w=whole(state[k]); if(document.activeElement!==u.inp) u.inp.value=w; u.frac.value=Math.round((state[k]-w)*16); u.range.value=state[k]; if(!u.help.classList.contains("err")) u.help.textContent=`${fmt(LIM[k][0])} to ${fmt(LIM[k][1])}`; }
  $("toast").textContent="";
  render();
}
/* CNC code: hidden line-item property "_cnc" -> paste into Shelfix CNC Export to get a Mozaik DXF */
function cncCode(){
  const r=(x)=>Math.round(x*16)/16, o={v:1,L:r(state.L),D:r(state.D),fin:state.fin.name,edge:EDGE_NAME[state.edge]};
  if(customActive()) o.pts=draw.points.map(p=>[r(p.x),r(state.D-p.y)]);           // X from left, Y from front
  else if(state.r) o.rad={c:["fl","fr","br","bl"].map(k=>state.cset[k]?1:0),r:r(state.r)};
  if(holesActive()) o.holes=holes.list.map(h=>[r(h.x),r(state.D-h.y),r(h.d)]);    // X from left, Y from front, diameter
  const note=$("drawNote").value.trim(); if(draw.on && note) o.note=note;
  return "SHX1:"+btoa(unescape(encodeURIComponent(JSON.stringify(o))));
}
/* ---------- Shopify: variant lookup (works past the 250-variant storefront limit) ---------- */
const ROOT_URL=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
const optCache={}, varCache={}; let priceTimer=0, priceSeq=0;
function parseSection(html){ const m=html.match(/<script type="application\/json" data-shx-variant>([\s\S]*?)<\/script>/); if(!m) throw new Error("lookup section missing"); return JSON.parse(m[1]); }
function lookup(handle, ids){ const q=ids?`&option_values=${ids.join(",")}`:"";
  return fetch(`${ROOT_URL}products/${handle}?section_id=shelfix-variant${q}`).then(r=>{ if(!r.ok) throw new Error("HTTP "+r.status); return r.text(); }).then(parseSection); }
function optionIds(fin){
  if(!optCache[fin.handle]) optCache[fin.handle]=lookup(fin.handle).then(d=>{ const map=d.options.map(o=>{ const m={}; o.values.forEach(v=>m[v.name]=v.id); return m; }); return map; });
  return optCache[fin.handle];
}
function getVariant(fin,L,D,edge){
  const key=`${fin.handle}|${L}|${D}|${edge}`;
  if(!varCache[key]) varCache[key]=optionIds(fin).then(map=>{
    const ids=[map[0][`${L}"`],map[1][`${D}"`],map[2][edge]];
    if(ids.some(x=>!x)) return null;
    return lookup(fin.handle,ids).then(d=>{ const v=d.variant;   // make sure Shopify returned the exact combination
      return (v.o1===`${L}"`&&v.o2===`${D}"`&&v.o3===edge)?v:null; });
  }).catch(e=>{ delete varCache[key]; throw e; });
  return varCache[key];
}
function money(x){ return "$"+x.toFixed(2); }
function schedulePrice(L,D,edge){
  const seq=++priceSeq; state.variant=null; $("add").disabled=true; $("price").textContent="…";
  clearTimeout(priceTimer);
  priceTimer=setTimeout(()=>{
    getVariant(state.fin,L,D,edge).then(v=>{ if(seq!==priceSeq) return;
      if(!v){ $("price").textContent="—"; $("toast").textContent="This size is not available online. Contact us for a quote."; return; }
      state.variant=v; $("price").textContent=money(v.price/100+(state.addon||0));
      $("add").disabled=!v.available || (customActive()?!CFG.shapeVariant:(state.r?!CFG.radiusVariants[cornerList().length]:false)) || (holesActive() && (!CFG.holeVariant || !holesValid()));
    }).catch(()=>{ if(seq!==priceSeq) return; $("price").textContent="—"; $("toast").textContent="Could not load the price. Please refresh the page."; });
  },140);
}
function addonLines(props){
  const tag={"For shelf":props["Exact size"]+" · "+state.fin.name}, out=[];
  if(customActive()){ if(CFG.shapeVariant) out.push({id:CFG.shapeVariant,quantity:1,properties:tag}); }
  else if(state.r){ const id=CFG.radiusVariants[cornerList().length]; if(id) out.push({id,quantity:1,properties:tag}); }
  if(holesActive() && CFG.holeVariant) out.push({id:CFG.holeVariant,quantity:holes.list.length,properties:tag});
  return out;
}
function lineProps(){
  const p={"Finish":state.fin.name,"Exact size":`${fmt(state.L)} L × ${fmt(state.D)} D`,"Edge banding":EDGE_NAME[state.edge]};
  if(customActive()) p["Custom shape"]=draw.points.map((q,i)=>`P${i+1} (${fmt(q.x)}, ${fmt(state.D-q.y)})`).join("; ");
  else if(state.r) p["Corners"]=`${cornerName()}, R ${fmt(state.r)}`;
  if(holesActive()) p["Holes"]=holes.list.map((h,i)=>`H${i+1} Ø ${fmt(h.d)} at X ${fmt(h.x)}, Y ${fmt(state.D-h.y)}`).join("; ")+" (from front-left)";
  const note=$("drawNote").value.trim(); if(draw.on&&note) p["Note"]=note;
  p["_cnc"]=cncCode();
  p["_shape"]=shapeProp();
  return p;
}
/* "_shape": plain numbers for the cart / packing slip drawing (snippets/shelfix-shelf-svg.liquid) */
function shapeProp(){
  const r=(x)=>Math.round(x*16)/16;
  let s=`L=${r(state.L)};D=${r(state.D)};e=${state.edge==="all"?"all":"front"}`;
  if(customActive()) s+=";p="+draw.points.map(q=>`${r(q.x)},${r(state.D-q.y)}`).join(" ");
  else if(state.r) s+=`;r=${r(state.r)};c=${["fl","fr","br","bl"].map(k=>state.cset[k]?1:0).join(",")}`;
  if(holesActive()) s+=";h="+holes.list.map(h=>`${r(h.x)},${r(state.D-h.y)},${r(h.d)}`).join(" ");
  return s+`;lt=${fmt(state.L)};dt=${fmt(state.D)}`;
}
$("add").addEventListener("click",()=>{
  const v=state.variant; if(!v) return;
  const props=lineProps(), extras=addonLines(props), extra=extras[0];
  if(window.SHX_PREVIEW){ $("cncOut").hidden=false; $("cncCode").value=props._cnc; $("toast").textContent=`Preview: adds variant ${v.id} (${v.o1} / ${v.o2} / ${v.o3})${extras.map(x=>` + add-on ${x.id}×${x.quantity}`).join("")} with ${Object.keys(props).length} properties.`; return; }
  const btn=$("add"); btn.disabled=true; $("toast").textContent="Adding to cart…";
  let first;
  if(draw.on && draw.file){
    const fd=new FormData(); fd.append("id",v.id); fd.append("quantity","1");
    Object.entries(props).forEach(([k,val])=>fd.append(`properties[${k}]`,val)); fd.append("properties[Drawing file]",draw.file);
    first=fetch(ROOT_URL+"cart/add.js",{method:"POST",body:fd,headers:{Accept:"application/json"}});
  } else {
    first=fetch(ROOT_URL+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:[{id:v.id,quantity:1,properties:props}]})});
  }
  first.then(r=>{ if(!r.ok) throw r; return extras.length?fetch(ROOT_URL+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:extras})}).then(r2=>{ if(!r2.ok) throw r2; }):null; })
   .then(()=>{ window.location.href=ROOT_URL+"cart"; })
   .catch(()=>{ btn.disabled=false; $("toast").textContent="Could not add to cart. Please try again."; });
});

$("cncCopy").addEventListener("click",()=>{ const t=$("cncCode"); (navigator.clipboard?navigator.clipboard.writeText(t.value):Promise.reject()).then(()=>{ $("cncCopy").textContent="Copied"; setTimeout(()=>$("cncCopy").textContent="Copy CNC code",1500); }).catch(()=>{ t.focus(); t.select(); }); });
if(!Object.keys(CFG.radiusVariants).length){ $("cornerOn").closest(".sec").hidden=true; }
if(!CFG.shapeVariant){ $("drawOn").closest(".sec").hidden=true; }
if(!CFG.holeVariant){ $("holeOn").closest(".sec").hidden=true; }
const hfee=ROOT.querySelector("[data-hole-fee]"); if(hfee) hfee.textContent="+$"+(HOLE_FEE||0)+" each";
const fee=ROOT.querySelector("[data-shape-fee]"); if(fee) fee.textContent="+$"+(CUSTOM_SHAPE_ADD||0);
syncCornerUI(); applyFinish(); resize(); setView("iso"); update();

}
function start(){ document.querySelectorAll("[data-sxd]").forEach(boot); }
if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",start); else start();
document.addEventListener("shopify:section:load",start);
window.ShelfixDesigner={boot:boot};
})();
